import React from 'react';
import PropTypes from 'prop-types';
import {WarningButton} from '../../../components'

const NursingFacilityNotifier = ({onClick, busy, disabled}) => (
  <WarningButton
    disabled={busy || disabled}
    onClick={onClick}>
    Notify NFs
  </WarningButton>
);

NursingFacilityNotifier.propTypes = {
  onClick: PropTypes.func.isRequired,
  busy: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default NursingFacilityNotifier;



// WEBPACK FOOTER //
// ./src/modules/sample/components/NursingFacilityNotifier.js